// components
import BrandListItem from "./BrandListItem/BrandListItem";
// images
import elring from "../../../../assets/images/elring.jpg";
import hengst from "../../../../assets/images/hengst.png";
import liquiMoly from "../../../../assets/images/liquiMoly.jpg";
import mahle from "../../../../assets/images/mahle.jpg";
import delphi from "../../../../assets/images/delphi.png";
import dayco from "../../../../assets/images/dayco.png";
import monroe from "../../../../assets/images/monroe.png";

// css
import classes from "./BrandsList.module.css";

const BrandList = () => (
  <ul
    className={[
      "mb-16",
      "flex",
      "justify-center",
      "gap-12",
      classes.BrandsContainer,
    ].join(" ")}
  >
    {/* Brands */}
    <BrandListItem imageSource={monroe} />
    <BrandListItem imageSource={delphi} />
    <BrandListItem imageSource={elring} />
    <BrandListItem imageSource={hengst} />
    <BrandListItem imageSource={liquiMoly} />
    <BrandListItem imageSource={mahle} />
    <BrandListItem imageSource={dayco} />

    {/* Brands Doubled */}

    <BrandListItem imageSource={monroe} />
    <BrandListItem imageSource={delphi} />
    <BrandListItem imageSource={elring} />
    <BrandListItem imageSource={hengst} />
    <BrandListItem imageSource={liquiMoly} />
    <BrandListItem imageSource={mahle} />
    <BrandListItem imageSource={dayco} />
  </ul>
);

export default BrandList;
